const regexpCache = Object.create(null)

export const constantBuilder = (constant, placeholders) => {
  Object.entries(placeholders).forEach(([key, value]) => {
    if (!regexpCache[key]) {
      regexpCache[key] = new RegExp(`__${key}__`, 'g')
    }
    constant = constant.replace(regexpCache[key], value)
  })
  return constant
}
